import React from 'react'
import Sketch from 'react-p5'

import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

const extensions = require("./extensions")
const wfc = require('wavefunctioncollapse');

let strings = new LocalizedStrings({
    en:{
        title:"wave function collapse",
        text:"of course we all know that our own reality depends on the structure of our consciousness we can objectify no more than a small part of our world ",
        description:"in quantum physics, the wave function is the idea that the unobserved state of a particle can be anything. as soon as the particle is observed, the possibilities disappear and the wave function collapses. the same idea is the foundation for the generation of this text. you can watch the algorithm observe states and entangled states thus create the text."
    },
    de: {
        title:"kollaps der wellenfunktion",
        text:"die wirklichkeit von der wir sprechen k#nnen ist nie die wirklichkeit an sich sondern eine von uns gestaltete wirklichkeit ",
        description:"in der quantenphysik entspricht die wellenfunktion der idee, dass unbeobachtete zustände eines partikels beliebig sein können. wenn das partikel einer beobachtung unterzogen wird, verschwinden die möglichkeiten und die wellenfunktion kollabiert. die selbe idee ist die grundlage der erzeugung dieses textes. sieh zu, wie das programm zustände und verschränkte zustände beobachtet und daraus den text schafft."
    }
});

class WaveFunctionCollapse extends React.Component {
    constructor(props) {
        super(props)

        this.model = null
        this.strPos = 0
        this.imgData = null
        this.sourceImgData = null
        this.sourceWidth = 15
        this.sourceHeight = 15
        this.destWidth = 40
        this.destHeight = 40
        this.patternSize = 1
        this.font = null
        this.minFontSize = 16
        this.fontSize = 16
        this.fontLoaded = false

        this.reset = this.reset.bind(this)
        this.setup = this.setup.bind(this)
        this.draw = this.draw.bind(this)
        this.windowResized = this.windowResized.bind(this)
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)
    }

    componentWillReceiveProps(props) {
        const { language } = this.props;

        if (props.language !== language) {
            strings.setLanguage(props.language)
            this.reset(this.p5)
        }
    }

    nextCh() {
        var ch = strings.text[this.strPos]
        this.strPos = (this.strPos + 1) % strings.text.length
        return ch
    }

    reset(p5) {
        this.fontSize = Math.max(window.innerWidth / 40, this.minFontSize)

        p5.textFont("DejaVuSansMono");
        p5.textSize(this.fontSize)

        this.sourceWidth = Math.floor(p5.random(8, 15))
        this.sourceHeight = Math.floor(p5.random(8, 15))
        this.destWidth = Math.floor(window.innerWidth / this.fontSize)
        this.destHeight = Math.floor(window.innerHeight / this.fontSize)-2

        var data = new Uint8ClampedArray(this.sourceWidth*this.sourceHeight*4)
        for (var i = 0; i < this.sourceWidth*this.sourceHeight*4; i += 4) {
            var chCode = this.nextCh().charCodeAt(0)
            data[i] = chCode
            data[i+1] = chCode
            data[i+2] = chCode
            data[i+3] = chCode
        }

        this.imgData = {data: data, width: this.sourceWidth, height: this.sourceHeight}
        this.model = new wfc.OverlappingModel(this.imgData.data, this.imgData.width, this.imgData.height, this.patternSize, this.destWidth, this.destHeight, extensions.maybe(), extensions.maybe(), 1);

        this.sourceImgData = p5.drawingContext.createImageData(this.sourceWidth, this.sourceHeight)
        for (var j = 0; j < this.sourceWidth*this.sourceHeight*4; j += 4) {
            for (var k = 0; k < 4; k++) {
                this.sourceImgData.data[j+k] = data[j+k]
            }
        }
    }

    setup(p5, canvasParentRef) {
        p5.createCanvas(window.innerWidth, window.innerHeight).parent(canvasParentRef)
        p5.background(0)

        p5.loadFont("./fonts/DejaVuSansMono.ttf", (font) => {
            this.font = font
            this.fontLoaded = true
        });

        this.reset(p5)
        this.p5 = p5
    }

    drawTextMatrix(p5, xp, yp, drawFontSize, matrix) {
        p5.textSize(drawFontSize)
        for (var y = 0; y < matrix.height; y++) {
            for (var x = 0; x < matrix.width; x++) {
                var ch = String.fromCharCode(matrix.data[4*(y*matrix.width+x)])

                if (ch === "#") {
                    ch = "ö"
                }
                p5.text(ch, xp+x*drawFontSize, yp+y*drawFontSize)
            }
        }
    }

    draw(p5) {
        p5.background(0)

        if (this.fontLoaded && this.model !== undefined) {
            this.model.iterate(1);

            var destImgData = p5.drawingContext.createImageData(this.destWidth, this.destHeight);
            this.model.graphics(destImgData.data);

            p5.fill(255)
            this.drawTextMatrix(p5, (window.innerWidth-destImgData.width*this.fontSize)/2, 70, this.fontSize, destImgData)
        }
    }

    windowResized(p5) {
        p5.resizeCanvas(window.innerWidth, window.innerHeight)
        p5.background(0)

        this.reset(p5)
    }

    render() {
        strings.setLanguage(this.context.language)
        return <Sketch setup={this.setup} draw={this.draw} windowResized={this.windowResized} />
    }
}
WaveFunctionCollapse.contextType = LanguageContext

export default WaveFunctionCollapse
